




































import Vue from "vue";
import Component from "vue-class-component";
import Footer from "@/components/organisms/Footer.vue";
import { Prop } from "vue-property-decorator";

@Component({
  components: { Footer },
})
export default class Auth extends Vue {
  name: "Auth";

  @Prop({ default: true })
  private isShowCard: boolean;

  get isFixedFooter(): boolean {
    return true;
    // return Element.clientHeight === Element.offsetHeight;
  }
}
